import React from "react"
import SearchResultsWithStore from "../../components/SearchResults/SearchResultsWithStore"
import {
  latestUpdatedTime,
  getSearchedAssetsWithTimeCalculations,
} from "../../helpers/searchAssets"
import PropTypes from "prop-types"

class FacilityAssets extends React.Component {
  render() {
    const formattedUpdateTime = this.props.loading
      ? null
      : latestUpdatedTime(this.props.allAssets)

    const { keywords, unitId, departmentId } = this.props

    const searchedAssets = getSearchedAssetsWithTimeCalculations(
      this.props.allAssets,
      { keywords, unitId, departmentId }
    )

    return (
      <SearchResultsWithStore
        deviceType={this.props.deviceType}
        formattedUpdateTime={formattedUpdateTime}
        searchedAssets={searchedAssets}
        loading={this.props.loading}
      />
    )
  }
}

FacilityAssets.propTypes = {
  allAssets: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  deviceType: PropTypes.string.isRequired,
  departmentId: PropTypes.string,
  unitId: PropTypes.string,
  keywords: PropTypes.string,
}

FacilityAssets.defaultProps = {
  allAssets: [],
  deviceType: "desktop",
  keywords: "",
  unitId: "",
  departmentId: "",
}

export default FacilityAssets
